import injector from 'vue-inject'
import firebase from 'firebase/app'
import 'firebase/auth'
import * as types from './mutation-types'
import { storeClient } from '@/service/apiClients'

export default {
  async signInWithGoogle (context) {
    firebase.auth().useDeviceLanguage()
    const provider = new firebase.auth.GoogleAuthProvider()
    provider.setCustomParameters({ 'prompt': 'select_account' })
    if (injector.get('platformUtils').isApp(process.env.VUE_APP_PLATFORM)) {
      await firebase.auth().signInWithPopup(provider)
    } else {
      await firebase.auth().signInWithPopup(provider)
    }
  },
  async signInWithEmailAndPassword (context, { email, password }) {
    try {
      await firebase.auth().signInWithEmailAndPassword(email, password)
    } catch (error) {
      if (error.code === 'auth/user-not-found' || error.code === 'auth/wrong-password') {
        alert('帳號/密碼錯誤')
      } else {
        alert('輸入資料不符合規格')
      }
    }
  },
  async createUser (context, { email, password }) {
    try {
      firebase.auth().useDeviceLanguage()
      await firebase.auth().createUserWithEmailAndPassword(email, password)
      firebase.auth().currentUser.sendEmailVerification()
      alert('註冊成功！請至您所填寫的 Email 收取認證信')
    } catch (error) {
      console.error(error.code)
      alert('錯誤: ' + error.message)
    }
  },
  async linkGoogleAccount ({ commit }) {
    try {
      const provider = new firebase.auth.GoogleAuthProvider()
      provider.setCustomParameters({ 'prompt': 'select_account' })
      const { user } = await firebase.auth().currentUser.linkWithPopup(provider)
      commit(types.SET_USER_INFO, user)
    } catch (e) {
      console.log(e.message)
    }
  },
  async unlinkAccount ({ commit }, providerId) {
    try {
      const user = await firebase.auth().currentUser.unlink(providerId)
      commit(types.SET_USER_INFO, user)
    } catch (e) {
      console.log(e.message)
    }
  },
  async updateProfile ({ state, commit }, { displayName = state.displayName, photoURL = state.photoURL }) {
    try {
      await firebase.auth().currentUser.updateProfile({ displayName, photoURL })
      commit(types.SET_USER_INFO, { displayName, photoURL })
    } catch (e) {
      console.error(e.message)
    }
  },
  async linkEmail ({ state, commit }, { email, password }) {
    try {
      const provider = new firebase.auth.GoogleAuthProvider()
      provider.setCustomParameters({ 'prompt': 'select_account' })
      await firebase.auth().currentUser.reauthenticateWithPopup(provider)

      const credential = await firebase.auth.EmailAuthProvider.credential(email, password)
      const { user } = await firebase.auth().currentUser.linkAndRetrieveDataWithCredential(credential)
      user.sendEmailVerification()
      commit(types.SET_USER_INFO, firebase.auth().currentUser)
    } catch (e) {
      console.error(e.message)
    }
  },
  async updateEmail ({ state, commit }, { email, password, newEmail }) {
    try {
      const credential = await firebase.auth.EmailAuthProvider.credential(email, password)
      const user = firebase.auth().currentUser
      await user.reauthenticateAndRetrieveDataWithCredential(credential)
      await user.updateEmail(newEmail)
      user.sendEmailVerification()
      commit(types.SET_USER_INFO, firebase.auth().currentUser)
    } catch (e) {
      console.error(e.message)
    }
  },
  async sendEmailVerification (context) {
    const user = firebase.auth().currentUser
    user.sendEmailVerification()
  },
  async getAllUserStores ({ commit }, uid) {
    const { data: stores } = await storeClient.get(`/users/${uid}/getAllStores`)
    commit(types.SET_STORES, stores)
  },
  async signOut (context, callback) {
    await firebase.auth().signOut()
    storeClient.removeAuthToken()
  }
}
